'use client';

import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { useLang } from './LanguageContext';

export default function FooterSection() {
  const { t } = useLang();

  const navLinks = [
    { key: 'nav_home', href: '#hero' },
    { key: 'nav_destinations', href: '#destinations' },
    { key: 'nav_uzbekistan', href: '#uzbekistan' },
    { key: 'nav_about', href: '#why' },
    { key: 'nav_contact', href: '#contact' },
  ];

  return (
    <footer className="border-t py-10 px-6 md:px-10" style={{ borderColor: 'rgba(201,168,76,0.12)' }}>
      <div className="max-w-8xl mx-auto">
        {/* Single row layout — Pattern 1 */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + tagline */}
          <div className="flex items-center gap-3">
            <AppLogo size={32} />
            <div>
              <div
                className="font-serif font-bold text-cream text-base"
                style={{ fontFamily: 'Fraunces, serif' }}
              >
                AirDubai<span className="text-shimmer">Travel</span>
              </div>
              <div className="text-muted text-xs mt-0.5">{t('footer_tagline')}</div>
            </div>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            {navLinks?.map((link) => (
              <a
                key={link?.key}
                href={link?.href}
                className="text-muted hover:text-gold transition-colors text-sm font-medium"
              >
                {t(link?.key)}
              </a>
            ))}
          </div>

          {/* Social icons */}
          <div className="flex items-center gap-3">
            {/* Telegram */}
            <a
              href="https://t.me/AIR_DUBAY"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
              className="w-9 h-9 rounded-full border flex items-center justify-center transition-all hover:border-[#0088CC] hover:bg-[#0088CC]/10"
              style={{ borderColor: 'rgba(255,255,255,0.1)' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8l-1.68 7.9c-.12.56-.46.7-.94.43l-2.6-1.92-1.25 1.2c-.14.14-.26.26-.53.26l.19-2.65 4.83-4.37c.21-.19-.05-.29-.32-.1l-5.97 3.76-2.57-.8c-.56-.17-.57-.56.12-.83l10.03-3.87c.46-.17.87.11.69.99z"
                  fill="#0088CC"
                />
              </svg>
            </a>

            {/* Instagram */}
            <a
              href="https://instagram.com/AIR_DUBAY"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 rounded-full border flex items-center justify-center transition-all hover:bg-pink-500/10"
              style={{ borderColor: 'rgba(255,255,255,0.1)' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <defs>
                  <linearGradient id="igGradFooter" x1="0" y1="1" x2="1" y2="0">
                    <stop offset="0%" stopColor="#F58529"/>
                    <stop offset="50%" stopColor="#DD2A7B"/>
                    <stop offset="100%" stopColor="#8134AF"/>
                  </linearGradient>
                </defs>
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="url(#igGradFooter)" strokeWidth="2"/>
                <circle cx="12" cy="12" r="5" stroke="url(#igGradFooter)" strokeWidth="2"/>
                <circle cx="17.5" cy="6.5" r="1.5" fill="url(#igGradFooter)"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Bottom row */}
        <div className="mt-8 pt-6 border-t flex flex-col md:flex-row items-center justify-between gap-3" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
          <p className="text-muted text-xs">{t('footer_legal')}</p>
          <div className="flex gap-4 text-xs text-muted">
            <a href="#" className="hover:text-gold transition-colors">Privacy</a>
            <span className="opacity-30">·</span>
            <a href="#" className="hover:text-gold transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}